/**

 * 气象农艺页间上下文：统一 farmId / landId / 坐标 query 读写与跳转拼接。

 */



export const WA_CONTEXT_KEYS = ['farmId', 'landId', 'lat', 'lng', 'address'];



export function readWeatherAgronomyContext(searchParams) {

  const get = (key) => {

    if (!searchParams) return '';

    if (typeof searchParams.get === 'function') return String(searchParams.get(key) || '').trim();

    return String(searchParams[key] || '').trim();

  };

  return {

    farmId: get('farmId'),

    landId: get('landId'),

    lat: get('lat'),

    lng: get('lng'),

    address: get('address'),

  };

}



/** @param {string|URLSearchParams} currentSearch @param {Record<string, string|number|null|undefined>} patch */

export function mergeWeatherAgronomySearch(currentSearch, patch = {}) {

  const raw =

    typeof currentSearch === 'string'

      ? currentSearch.replace(/^\?/, '')

      : currentSearch instanceof URLSearchParams

        ? currentSearch.toString()

        : '';

  const params = new URLSearchParams(raw);

  Object.entries(patch || {}).forEach(([key, value]) => {

    if (!WA_CONTEXT_KEYS.includes(key)) return;

    if (value == null || String(value).trim() === '') params.delete(key);

    else params.set(key, String(value).trim());

  });

  return params.toString();

}



/** 只抽取气象农艺上下文键，避免页内杂参跨页污染 */

export function pickWeatherAgronomySearch(search) {

  const raw =

    typeof search === 'string'

      ? search.replace(/^\?/, '')

      : search instanceof URLSearchParams

        ? search.toString()

        : '';

  const params = new URLSearchParams(raw);

  return mergeWeatherAgronomySearch('', readWeatherAgronomyContext(params));

}



/** 在现有 search 上拼接 path；默认只保留 WA 上下文 */

export function withWeatherAgronomySearch(path, search) {

  const base = String(path || '').split('?')[0];

  let q = '';

  if (typeof search === 'string') {

    q = pickWeatherAgronomySearch(search);

  } else if (search instanceof URLSearchParams) {

    q = pickWeatherAgronomySearch(search);

  } else if (search && typeof search === 'object') {

    q = mergeWeatherAgronomySearch('', search);

  }

  return q ? `${base}?${q}` : base;

}



export function buildWeatherAgronomyPath(path, ctx = {}, currentSearch = '') {

  const next = mergeWeatherAgronomySearch(pickWeatherAgronomySearch(currentSearch), ctx);

  return withWeatherAgronomySearch(path, next);

}


